





















































import { defineComponent, PropType } from '@vue/composition-api';

import BaseButton from '@/base/app/components/atoms/BaseButton.vue';
import BaseLink from '@/base/app/components/atoms/BaseLink.vue';
import CourseBackground from '@/base/app/components/molecules/CourseBackground.vue';
import { LocalDateTime } from '@/base/types';

import { PropsUserExamFlexCard, useUserExamFlexCard } from './UserExamFlexCardComposable';

type Props = PropsUserExamFlexCard;

export default defineComponent({
  name: 'HomeUserExamFlexCard',
  components: { BaseButton, BaseLink, CourseBackground },
  inheritAttrs: false,
  props: {
    id: { type: String, required: true },
    name: { type: String, required: true },
    contentId: { type: String, required: true },
    courseId: { type: String, required: true },
    courseName: { type: String, required: true },
    courseColor: { type: String, default: undefined },
    courseImage: { type: String, default: undefined },
    courseFontColorOnImage: { type: String, default: undefined },
    scheduledStart: { type: Object as PropType<LocalDateTime>, required: true },
    scheduledFinish: { type: Object as PropType<LocalDateTime>, default: undefined },
    finishedAt: { type: Object as PropType<LocalDateTime>, default: undefined },
    status: { type: String, required: true },
    times: { type: Number, required: true },
    timeLimit: { type: Number, default: undefined },
    groupExamId: { type: String, required: true },
    groupExamStatus: { type: String, required: true },
    groupId: { type: String, required: true },
    groupName: { type: String, default: undefined },
    groupRole: { type: String, default: undefined },
    adminMode: { type: Boolean, default: false },
    hideCourseName: { type: Boolean, default: false },
    backgroundCols: { type: Number, default: 3 },
    chipXSmall: { type: Boolean, default: false },
    returnQuery: { type: Object, default: undefined },
  },
  setup(props: Props) {
    return useUserExamFlexCard(props);
  },
});
